export default __webpack_public_path__ + "static/media/plan-added-image.f7b009ea.svg";